import { render, staticRenderFns } from "./PostalCodesZones.vue?vue&type=template&id=48a2e558&scoped=true&"
import script from "./PostalCodesZones.vue?vue&type=script&lang=js&"
export * from "./PostalCodesZones.vue?vue&type=script&lang=js&"
import style0 from "./PostalCodesZones.vue?vue&type=style&index=0&id=48a2e558&scoped=true&lang=css&"
import style1 from "./PostalCodesZones.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a2e558",
  null
  
)

export default component.exports